import swal from "sweetalert";
import {
  CREATE_TYPE_FIELD_FAIL,
  CREATE_TYPE_FIELD_REQUEST,
  CREATE_TYPE_FIELD_SUCCESS,
  FETCH_TYPE_FIELD_BY_LIST_NAME_FAIL,
  FETCH_TYPE_FIELD_BY_LIST_NAME_REQUEST,
  FETCH_TYPE_FIELD_BY_LIST_NAME_SUCCESS,
  FETCH_TYPE_FIELD_FAIL,
  FETCH_TYPE_FIELD_REQUEST,
  FETCH_TYPE_FIELD_SUCCESS,
  FETCH_TYPE_FIELD_VALUE_FAIL,
  FETCH_TYPE_FIELD_VALUE_REQUEST,
  FETCH_TYPE_FIELD_VALUE_SUCCESS,
  SHOW_TYPE_FIELD_FAIL,
  SHOW_TYPE_FIELD_REQUEST,
  SHOW_TYPE_FIELD_SUCCESS,
  UPDATE_TYPE_FIELD_FAIL,
  UPDATE_TYPE_FIELD_REQUEST,
  UPDATE_TYPE_FIELD_SUCCESS,
} from "../../ActionType/TypeFieldTypes/TypeFieldTypes";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const getTypeFieldAction = (id) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      type_of_help_id: id,
    },
  };

  dispatch({
    type: FETCH_TYPE_FIELD_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("typeField", config);
    const { status, data } = response;
    if (status == 200) {
      dispatch({
        type: FETCH_TYPE_FIELD_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_TYPE_FIELD_FAIL,
      payload: [],
    });
  }
};

export const getTypeFieldByListNameAction =
  (typeListName) => async (dispatch) => {
    
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        typeListName,
      },
    };

    dispatch({
      type: FETCH_TYPE_FIELD_BY_LIST_NAME_REQUEST,
      payload: [],
    });
    try {
      const response = await api.get("typeField/getByListName", config);
      const { status, data } = response;
      // console.log("data11 : ",data);
      if (status == 200) {
        dispatch({
          type: FETCH_TYPE_FIELD_BY_LIST_NAME_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_TYPE_FIELD_BY_LIST_NAME_FAIL,
        payload: [],
      });
    }
  };

export const showTypeFieldAction = (id) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: SHOW_TYPE_FIELD_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("typeField/show/" + id, config);
    const { status, data } = response;
    if (status == 200) {
      dispatch({
        type: SHOW_TYPE_FIELD_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: SHOW_TYPE_FIELD_FAIL,
      payload: [],
    });
  }
};

export const udpateTypeFieldAction =
  (id, name, label, placeholder, type, typeOfHelpId) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: UPDATE_TYPE_FIELD_REQUEST,
      payload: [],
    });
    try {
      const response = await api.put(
        "typeField/update/" + id,
        { name, label, placeholder, type, type_of_help_id: typeOfHelpId },
        config
      );
      const { status, data } = response;
      if (status == 200) {
        dispatch(getTypeFieldAction(typeOfHelpId));
        dispatch(getTypeFieldAction(typeOfHelpId));

        dispatch({
          type: UPDATE_TYPE_FIELD_SUCCESS,
          payload: data,
        });
        swal({
          title: "Good job!",
          text: "Type Field was updated Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_TYPE_FIELD_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  };

export const creatTypeFieldAction =
  (type_of_help_id, name, label, placeholder, type,closeModal) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: CREATE_TYPE_FIELD_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "typeField/create",
        { type_of_help_id, name, label, placeholder, type },
        config
      );
      const { status, data } = response;
      if (status == 201) {
        closeModal()
        dispatch({
          type: CREATE_TYPE_FIELD_SUCCESS,
          payload: data,
        });
        swal({
          title: "Good job!",
          text: "Type Field  was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
      }
    } catch (error) {
      dispatch({
        type: CREATE_TYPE_FIELD_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  };

export const getTypeFieldValueAction = (typeFieldId) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      type_field_id: typeFieldId,
    },
  };

  dispatch({
    type: FETCH_TYPE_FIELD_VALUE_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("typeFieldValue", config);
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: FETCH_TYPE_FIELD_VALUE_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_TYPE_FIELD_VALUE_FAIL,
      payload: [],
      error: error.response.data.errors,
    });
  }
};
export const creatTypeFieldValueAction =
  (typeFieldId, value) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: CREATE_TYPE_FIELD_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "typeFieldValue/create",
        { type_field_id: typeFieldId, value },
        config
      );
      const { status, data } = response;
      if (status == 201) {
        dispatch(getTypeFieldValueAction(typeFieldId));
        dispatch(getTypeFieldValueAction(typeFieldId));
        dispatch({
          type: CREATE_TYPE_FIELD_SUCCESS,
          payload: data,
        });
        swal({
          title: "Good job!",
          text: "Type Field value  was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: CREATE_TYPE_FIELD_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  };

export const updateTypeFieldValueAction =
  (id, value, typeFieldId) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    try {
      const response = await api.put(
        "typeFieldValue/update/" + id,
        { value },
        config
      );
      const { status, data } = response;
      if (status == 200) {
        dispatch(getTypeFieldValueAction(typeFieldId));
        dispatch(getTypeFieldValueAction(typeFieldId));
        swal({
          title: "Good job!",
          text: "Type Field value  was update Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
      }
    } catch (error) {
      dispatch({
        type: CREATE_TYPE_FIELD_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  };

export const deleteTypeFieldValueAction =
  (id, typeFieldId) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    try {
      const response = await api.delete("typeFieldValue/delete/" + id, config);
      const { status } = response;
      if (status == 200) {
        dispatch(getTypeFieldValueAction(typeFieldId));
        dispatch(getTypeFieldValueAction(typeFieldId));
        swal({
          title: "Good job!",
          text: "Type Field value  was Delete Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
      }
    } catch (error) {
      dispatch({
        type: CREATE_TYPE_FIELD_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  };
